import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CardPaymentCancelComponent } from './card-payment-cancel.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

const routes: Routes = [
  {
    path: '',
    component: CardPaymentCancelComponent
  }
];

@NgModule({
  declarations: [CardPaymentCancelComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    MatSnackBarModule
  ]
})
export class CardPaymentCancelModule { } 